import getItems from './getItems'

export default {
  ...getItems
}
